<template>
  <div>

    <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="navbar-component _2 w-nav">
      <div class="navbar-container w-container">
        <a id="w-node-_2bc7849c-fc53-2a49-059f-aa960ee8e78d-0ee8e78b" @click="goToHome" class="navbar-logo-link no-rizer w-nav-brand"><img src="../../../../../public/images/Logo.svg" loading="lazy" alt="" class="navbar-logo"></a>
      </div>
    </div>
    <div class="section color mid-line">
      <div data-w-id="8a817dec-33d8-ba64-0999-5e0ddc2f3a81" class="container last form one w-container">
        <div class="form-regidet w-form">
          <div class="wrap-steps">
            <div class="step">
              <div class="step-number active">
                <div class="number-txt">1</div>
                <div data-w-id="d73203a7-f081-4301-5c74-acb811806f80" class="pulse"></div>
              </div>
            </div>
            <div class="step">
              <div class="step-number">
                <div>2</div>
              </div>
            </div>
          </div>
          <form id="wf-form-signup-2" name="wf-form-signup-2" data-name="signup" method="get" data-ms-form="signup" class="form-input-regidet" data-wf-page-id="652921c910bae02d8870dddd" data-wf-element-id="d73203a7-f081-4301-5c74-acb811806f90">
            <v-form ref="form_reg1" v-model="valid_reg1" lazy-validation>
              <div class="line-progress"></div>
              <div class="tittle-form">
                <h1 class="heading-form">Общие сведения</h1>
                <div class="text-classic-link">Уже есть аккант? <a @click="goToLogin" class="link-form">Вход</a>
                </div>
              </div>
              <div class="w-layout-vflex flex-form" style="margin-top: 15px;">
                <div class="w-layout-hflex flex-input">
<!--                  <div class="input-box">-->
<!--                    <label for="Last-Name-2" class="input-label">Фамилия</label>-->
<!--                    <v-text-field-->
<!--                        id="Last-Name-2"-->
<!--                        name="Last-Name-2"-->
<!--                        outlined-->
<!--                        type="text"-->
<!--                        inputmode="text"-->
<!--                        :rules="nameRules"-->
<!--                        v-model="registration_data.profile.surname"-->
<!--                    ></v-text-field>-->
<!--                  </div>-->
                  <div class="input-box">
                    <label for="First-Nam" class="input-label">Имя</label>
                    <v-text-field
                        id="First-Name"
                        name="First-Name"
                        outlined
                        inputmode="text"
                        type="text"
                        :rules="nameRules"
                        v-model="registration_data.profile.name"
                    ></v-text-field>
                  </div>
                </div>
<!--                <div class="w-layout-hflex flex-input">-->
<!--                  <div class="input-box">-->
<!--                    <label for="Last-Last-Name" class="input-label">Отчество</label>-->
<!--                    <v-text-field-->
<!--                        id="Last-Last-Name"-->
<!--                        name="Last-Last-Name"-->
<!--                        outlined-->
<!--                        inputmode="text"-->
<!--                        type="text"-->
<!--                        :rules="middleNameRules"-->
<!--                        v-model="registration_data.profile.middle_name"-->
<!--                    ></v-text-field>-->
<!--                  </div>-->

<!--                  <label class="w-checkbox checkbox-wrap-next">-->
<!--                    <div class="w-checkbox-input w-checkbox-input&#45;&#45;inputType-custom ms-checkbox-2"-->
<!--                         :class="{ 'w&#45;&#45;redirected-checked': dontHaveMiddleName }"-->
<!--                         @click.prevent="toggleCheckbox">-->
<!--                    </div>-->
<!--                    <input-->
<!--                        v-model="dontHaveMiddleName"-->
<!--                        type="checkbox"-->
<!--                        style="opacity:0;position:absolute;z-index:-1">-->
<!--                    <span class="text-classic top w-form-label" for="Last-Last-Name">Без отчества</span>-->
<!--                  </label>-->
<!--                </div>-->

                <div class="w-layout-hflex flex-input">
                  <div class="input-box">
                    <label for="Phone" class="input-label">Телефон</label>
                    <v-text-field
                        id="Phone"
                        name="Phone"
                        outlined
                        inputmode="numeric"
                        type="tel"
                        v-mask="'+7##########'"
                        :rules="phoneRules"
                        v-model="registration_data.profile.phone"
                    ></v-text-field>
                  </div>
                  <div class="input-box"></div>
                </div>

                <label class="w-checkbox checkbox-wrap-next">
                  <div
                      class="w-checkbox-input w-checkbox-input--inputType-custom ms-checkbox-2"
                      :class="{ 'w--redirected-checked': agreement_6 }"
                      @click.prevent="agreement_6 = !agreement_6">
                  </div>
                  <input
                      v-model="agreement_6"
                      type="checkbox"
                      name="Soglachenie-2"
                      id="Soglachenie-2"
                      data-name="Soglachenie 2"
                      style="opacity:0;position:absolute;z-index:-1">
                  <span
                      @click.prevent="agreement_6 = !agreement_6"
                      class="text-classic top w-form-label"
                      for="Soglachenie-2">Я ознакомлен с <a @click="goToDocument('privacy-policy')" class="link-form">Политикой в отношении обработки персональных данных</a> и даю <a @click="goToDocument('processing-personal-data')" class="link-form">Согласие</a> на обработку персональных данных и <a @click="goToDocument('promotional-materials')" class="link-form">Согласие</a> на получение рекламных материалов</span>
                </label>
              </div>

              <a
                  id="openLabel"
                  @click="sendPhone"
                  style="margin-top: 15px;"
                  aria-current="page"
                  class="button-bust w-button w--current">
                Продолжить
              </a>
              <link rel="prerender" @click="sendPhone">
            </v-form>
          </form>
        </div>
      </div>
    </div>

    <div class="floating-block">
      <button @click="redirectWithParams" class="back-button">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Назад
      </button>
    </div>

    <Footer />

  </div>
</template>

<script>
import { Footer } from '/src/app/shared/components';
import loadjs from 'loadjs';

export default {
  install(Vue, options) {
    // Проверяем, что ym существует
    const ym = window.ym;
    
    if (!ym) {
      console.warn('Yandex Metrika не загружена');
    }
    
    // Добавляем глобальный метод
    Vue.prototype.$ym = (goal, params = {}) => {
      if (window.ym) {
        const counterId = options.counterId || 106349139;
        window.ym(counterId, 'reachGoal', goal, params);
      } else {
        console.warn(`YM не доступна: цель ${goal} не отправлена`);
      }
    };
  },
  name: 'RegistrationStep1',
  data() {
    return {
      valid_reg1: false,

      nameRules: [
        v => this.dontHaveMiddleName || !!v || 'Поле не может быть пустым',
        v => (v && v.length <= 256) || 'Максимальная длина 256 символов'
      ],
      emailRules: [
        v => !!v || 'Поле не может быть пустым',
        v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Неправильный формат email'
      ],
      phoneRules: [
        v => !!v || 'Поле не может быть пустым',
        v => /^(8\d{10}|\+7\d{10})$/.test(v) || 'Телефон должен состоять из 11 цифр и начинаться с 8 или +7'
      ],

      dontHaveMiddleName: false,

      agreement_6: false
    };
  },
  components: {
    Footer
  },
  computed: {
    middleNameRules() {
      return [
        v => this.validateMiddleName(v) || 'Поле не может быть пустым',
        v => !v || v.length <= 256 || 'Максимальная длина 256 символов'
      ];
    },
    registration_data: {
      get() {
        return this.$store.getters.REGISTRATION_DATA;
      },
      set(value) {
        this.$store.commit('SET_REGISTRATION_DATA', value);
      }
    }
  },
  created() {
  },
  methods: {
    validateMiddleName(value) {
      // Если галочка установлена, позволяем оставить поле пустым
      if (this.dontHaveMiddleName) {
        return true;
      }
      // В противном случае, проверяем что поле не пустое
      return !!value;
    },
    goToDocument(name_doc) {
      this.$router.push('/documents/' + name_doc);
    },
    toggleCheckbox() {
      this.dontHaveMiddleName = !this.dontHaveMiddleName;
    },
    goToLogin() {
      this.$router.push('/login');
    },
    goToHome() {
      this.$router.push('/');
    },
    redirectWithParams() {
      const queryString = this.$router.resolve({
        path: '/',
        query: this.$route.query
      }).href.split('?')[1] || '';

      // Убираем возможный aff_sub1 из queryString (простая замена)
      const cleanQueryString = queryString.replace(/(^|&)aff_sub1=[^&]*/g, '');

      let url = `https://crapinka.ru/JdR4FycZ?aff_sub4=showcase&aff_sub1=vsemzaymi`;

      // Добавляем очищенные параметры, если они не пустые
      if (cleanQueryString && cleanQueryString !== '&') {
        // Убираем лишний & в начале, если он появился
        const finalParams = cleanQueryString.replace(/^&/, '');
        if (finalParams) {
          url += `&${finalParams}`;
        }
      }

      console.log('Final URL:', url);
      window.open(url, '_blank');
    },
    sendPhone() {
      if (this.$refs.form_reg1.validate()) {
        if (this.agreement_6){
          // Получаем параметры через Vue Router
          const params = this.$route.query;

          // Если нужно в старом формате (ваш вариант)
          const queryString = Object.keys(params)
              .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
              .join('&');

          let jsonParams = queryString
              ? JSON.parse(`{"${decodeURI(queryString).replace(/&/g, '","').replace(/=/g, '":"')}"}`)
              : {};

          jsonParams.aff_sub1 = 'vsemzaymi';

          this.registration_data.profile.surname = 'Empty';

          this.registration_data.aff_subs = jsonParams;
          this.$store.dispatch('REGISTRATION', this.registration_data)
              .then(() => {
                this.$ym('regoption3'); // Вместо ym(106349139,'reachGoal','regoption3')
                this.$router.push('/registration-step4');
              })
              .catch((error) => {
                this.$buefy.toast.open({
                  message: error,
                  type: 'is-danger'
                });
              });
        } else {
          this.$buefy.toast.open({
            message: 'Примите соглашения',
            type: 'is-danger'
          });
        }
      } else {
        this.$buefy.toast.open({
          message: 'Заполните корректно поля!',
          type: 'is-danger'
        });
      }
    },
  },
  mounted() {
    /* грузим jquery и webflow */
    loadjs(
        "https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=652921c910bae02d8870dddf",
        {
          success: () => {
            loadjs('./js/webflow.js', {
              success: () => {
              },
              error: () => {
                console.error('Failed to load Webflow');
              }
            });
          },
          error: () => {
            console.error('Failed to load jQuery');
          }
        }
    );
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      window.scrollTo(0, 0);
    });
  },
};
</script>

<style>
</style>
